































































import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "Cover"
})
export default class extends Vue {
  public topPhotoIndex = 0;
  public bottomPhotoIndex = 1;
  public nextPhotoIndex = 2;
  public rotationDegrees = 0;
  public visibleSlot = "top";
  public isTurning = false;
  private totalHeroPhotos = 16;
  public captions = [
    {
      key: "set-for-life",
      kickerNl: "Punch Set for Life",
      kickerEn: "Punch Set for Life",
      titleNl: "OWee 2026",
      titleEn: "OWee 2026",
      textNl: "",
      textEn: ""
    },
    {
      key: "pand-friday",
      kickerNl: "Elke vrijdag",
      kickerEn: "Every Friday",
      titleNl: "naar 't Pand",
      titleEn: "to 't Pand",
      textNl: "",
      textEn: ""
    },
    {
      key: "study-volleybal",
      kickerNl: "Punch",
      kickerEn: "Punch",
      titleNl: "Combineer studeren met volleybal",
      titleEn: "Combine studying with volleyball",
      textNl: "",
      textEn: ""
    },
    {
      key: "love-volleybal",
      kickerNl: "OWee",
      kickerEn: "OWee",
      titleNl: "Ontdek jouw liefde voor volleybal",
      titleEn: "Discover your love for volleyball",
      textNl: "",
      textEn: ""
    }
  ];
  private photoTimer = 0;

  public mounted() {
    this.photoTimer = window.setTimeout(() => {
      this.rotateHeroPhoto();
      this.photoTimer = window.setInterval(this.rotateHeroPhoto, 5200);
    }, 8200);
  }

  public beforeDestroy() {
    window.clearTimeout(this.photoTimer);
    window.clearInterval(this.photoTimer);
  }

  get photoWheelStyle() {
    return {
      transform: `rotate(${this.rotationDegrees}deg)`
    };
  }

  get topPhotoClass() {
    return `hero-photo-${this.topPhotoIndex + 1}`;
  }

  get bottomPhotoClass() {
    return `hero-photo-${this.bottomPhotoIndex + 1}`;
  }

  get currentPhotoIndex() {
    return this.visibleSlot === "top"
      ? this.topPhotoIndex
      : this.bottomPhotoIndex;
  }

  get currentCaption() {
    return this.captions[this.currentPhotoIndex % this.captions.length];
  }

  public rotateHeroPhoto() {
    if (this.isTurning) {
      return;
    }

    this.isTurning = true;
    this.rotationDegrees += 180;

    window.setTimeout(() => {
      if (this.visibleSlot === "top") {
        this.topPhotoIndex = this.nextPhotoIndex;
        this.visibleSlot = "bottom";
      } else {
        this.bottomPhotoIndex = this.nextPhotoIndex;
        this.visibleSlot = "top";
      }

      this.nextPhotoIndex = (this.nextPhotoIndex + 1) % this.totalHeroPhotos;
      this.isTurning = false;
    }, 1400);
  }
}
